<template>
    <g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.292893 0.792893C0.683417 0.402369 1.31658 0.402369 1.70711 0.792893L7 6.08579L12.2929 0.792893C12.6834 0.402369 13.3166 0.402369 13.7071 0.792893C14.0976 1.18342 14.0976 1.81658 13.7071 2.20711L7.70711 8.20711C7.31658 8.59763 6.68342 8.59763 6.29289 8.20711L0.292893 2.20711C-0.0976311 1.81658 -0.0976311 1.18342 0.292893 0.792893Z"
            :fill="iconFill"
        />
    </g>
</template>
<script>
export default {
    name: "NextDown14_8",
    props: {
        iconFill: {
            type: String,
            default: "#6F7287",
        },
    },
};
</script>
